// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.input-label {
    font-size: 1.125rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(3 21 10 / var(--tw-text-opacity, 1));
}

.input-field {
    margin-top: 0.125rem;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(234 234 234 / var(--tw-border-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(3 21 10 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.input-field:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
}

@media (min-width: 1400px) {

    .input-field {
        border-radius: 0.75rem;
        border-width: 0.0625rem;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        font-size: 1.0625rem;
    }
}

.input-field-compact {
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(234 234 234 / var(--tw-border-opacity, 1));
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(3 21 10 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.input-field-compact:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
}

@media (min-width: 1400px) {

    .input-field-compact {
        font-size: 1.0625rem;
    }
}

/* date picker input */
.input-date-field {
    margin-top: 0.125rem;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(234 234 234 / var(--tw-border-opacity, 1));
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-inline-start: 1rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(3 21 10 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}
.input-date-field:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
}
@media (min-width: 1400px) {

    .input-date-field {
        border-radius: 0.75rem;
        border-width: 0.0625rem;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        font-size: 1.0625rem;
    }
}


.input-date-field-custom {
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(234 234 234 / var(--tw-border-opacity, 1));
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-inline-start: 1rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(3 21 10 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}


.input-date-field-custom:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
}


@media (min-width: 1400px) {

    .input-date-field-custom {
        border-radius: 0.75rem;
        border-width: 0.0625rem;
        padding-top: 0.875rem;
        padding-bottom: 0.875rem;
        font-size: 1.0625rem;
    }
}

.input-prefix-content {
    border-right-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(230 232 234 / var(--tw-border-opacity, 1));
    padding-right: 0.75rem;
    font-size: 1.0625rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.input-with-prefix {
    display: block;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    border-color: ;
    padding: 0.75rem;
    padding-inline-start: 5rem;
    font-size: 1.0625rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(230 232 234 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.input-with-prefix:focus {
    border-color: ;
    --tw-ring-color: ;
}

@media (min-width: 1400px) {

    .input-with-prefix {
        border-radius: 0.75rem;
        padding: 1rem;
        padding-inline-start: 5rem;
    }
}

.checkbox-label {
    font-size: 1.0625rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.checkbox {
    height: 1.25rem;
    width: 1.25rem;
    cursor: pointer;
    border-radius: 0.375rem;
    border-width: 2px;
    border-color: ;
    background-color: ;
}

@media (min-width: 1400px) {

    .checkbox {
        height: 1.5rem;
        width: 1.5rem;
    }
}

.prefix-icon {
    pointer-events: none;
    position: absolute;
    top: 0px;
    bottom: 0px;
    inset-inline-start: 0px;
    display: flex;
    align-items: center;
    padding-inline-start: 1.25rem;
}

@media (min-width: 1400px) {

    .prefix-icon {
        padding-inline-start: 1.5rem;
    }
}

.input-error {
    --tw-border-opacity: 1;
    border-color: rgb(253 105 101 / var(--tw-border-opacity, 1));
}

@media (min-width: 1400px) {

    .input-error {
        border-width: 2px;
    }
}

.input-prefix-error {
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(253 105 101 / var(--tw-border-opacity, 1));
}

@media (min-width: 1400px) {

    .input-prefix-error {
        border-radius: 0.75rem;
        border-width: 2px;
    }
}

.error-msg {
    font-size: 0.938rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(253 105 101 / var(--tw-text-opacity, 1));
}

.input-suffix {
    position: absolute;
    top: 0px;
    bottom: 0px;
    right: 0.75rem;
    display: flex;
    align-items: center;
}

.search-input {
    display: block;
    width: 100%;
    border-radius: 0.625rem;
    border-width: 0.0625rem;
    border-color: ;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.5rem;
    padding-inline-start: 2.5rem;
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.025em;
}

.search-input::placeholder {
    --tw-text-opacity: 1;
    color: rgb(154 161 157 / var(--tw-text-opacity, 1));
}

.search-input:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
    --tw-ring-color: ;
}

@media (min-width: 1400px) {

    .search-input {
        border-radius: 0.75rem;
        border-width: 2px;
        font-size: 1.0625rem;
    }
}

.select-field {
    cursor: pointer;
    border-radius: 0.625rem;
    border-width: 0.0625rem;
    border-color: ;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.select-field:focus {
    border-color: ;
    --tw-ring-color: ;
}

@media (min-width: 1400px) {

    .select-field {
        border-width: 2px;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
        font-size: 1.0625rem;
    }
}

/* Styling for custom option */
.custom-option {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    cursor: pointer;
}
  
.custom-option:hover {
    background-color: #f0f0f0;
}

.custom-option-image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
}

.css-hlgwow .css-19bb58m {
    display: flex;
    align-items: center;
}

.css-hlgwow .css-19bb58m img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 10px;
}

.word-breack-all {
    word-break: break-all !important;
}

/* .css-b62m3t-container{
    @apply w-fit
} */
/* Styling only the border of the select field */
.css-b62m3t-container .css-13cymwt-control {
    border-radius: 0.75rem;
    border-color: ;
    padding: 0.25rem;
    font-size: 1rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(230 232 234 / var(--tw-text-opacity, 1));
}
@media (min-width: 1400px) {

    .css-b62m3t-container .css-13cymwt-control {
        font-size: 1.0625rem;
    }
}



 `, "",{"version":3,"sources":["webpack://./src/styles/input.css"],"names":[],"mappings":";;AAGI;IAAA,mBAAwC;IAAxC,gBAAwC;IAAxC,oBAAwC;IAAxC;AAAwC;;AAIxC;IAAA,oBAA0N;IAA1N,WAA0N;IAA1N,qBAA0N;IAA1N,iBAA0N;IAA1N,sBAA0N;IAA1N,4DAA0N;IAA1N,kBAA0N;IAA1N,mBAA0N;IAA1N,qBAA0N;IAA1N,wBAA0N;IAA1N,eAA0N;IAA1N,gBAA0N;IAA1N,oBAA0N;IAA1N,+CAA0N;IAA1N,wJAA0N;IAA1N,wDAA0N;IAA1N;AAA0N;;AAA1N;IAAA,cAA0N;IAA1N,8BAA0N;IAA1N;AAA0N;;AAA1N;;IAAA;QAAA,sBAA0N;QAA1N,uBAA0N;QAA1N,oBAA0N;QAA1N,uBAA0N;QAA1N;IAA0N;AAAA;;AAI1N;IAAA,WAA2K;IAA3K,qBAA2K;IAA3K,iBAA2K;IAA3K,sBAA2K;IAA3K,4DAA2K;IAA3K,qBAA2K;IAA3K,sBAA2K;IAA3K,mBAA2K;IAA3K,sBAA2K;IAA3K,eAA2K;IAA3K,gBAA2K;IAA3K,oBAA2K;IAA3K,+CAA2K;IAA3K,wJAA2K;IAA3K,wDAA2K;IAA3K;AAA2K;;AAA3K;IAAA,cAA2K;IAA3K,8BAA2K;IAA3K;AAA2K;;AAA3K;;IAAA;QAAA;IAA2K;AAAA;;AAG/K,sBAAsB;AAElB;IAAA,oBAAkN;IAAlN,qBAAkN;IAAlN,iBAAkN;IAAlN,sBAAkN;IAAlN,4DAAkN;IAAlN,qBAAkN;IAAlN,wBAAkN;IAAlN,0BAAkN;IAAlN,eAAkN;IAAlN,gBAAkN;IAAlN,oBAAkN;IAAlN,+CAAkN;IAAlN,wJAAkN;IAAlN,wDAAkN;IAAlN;AAAkN;AAAlN;IAAA,cAAkN;IAAlN,8BAAkN;IAAlN;AAAkN;AAAlN;;IAAA;QAAA,sBAAkN;QAAlN,uBAAkN;QAAlN,oBAAkN;QAAlN,uBAAkN;QAAlN;IAAkN;AAAA;;;AAKlN;IAAA,qBAA6M;IAA7M,iBAA6M;IAA7M,sBAA6M;IAA7M,4DAA6M;IAA7M,oBAA6M;IAA7M,uBAA6M;IAA7M,0BAA6M;IAA7M,eAA6M;IAA7M,gBAA6M;IAA7M,oBAA6M;IAA7M,+CAA6M;IAA7M,wJAA6M;IAA7M,wDAA6M;IAA7M;AAA6M;;;AAA7M;IAAA,cAA6M;IAA7M,8BAA6M;IAA7M;AAA6M;;;AAA7M;;IAAA;QAAA,sBAA6M;QAA7M,uBAA6M;QAA7M,qBAA6M;QAA7M,wBAA6M;QAA7M;IAA6M;AAAA;;AAI7M;IAAA,uBAAyE;IAAzE,sBAAyE;IAAzE,4DAAyE;IAAzE,sBAAyE;IAAzE,oBAAyE;IAAzE,gBAAyE;IAAzE,oBAAyE;IAAzE;AAAyE;;AAIzE;IAAA,cAAwM;IAAxM,WAAwM;IAAxM,qBAAwM;IAAxM,iBAAwM;IAAxM,cAAwM;IAAxM,gBAAwM;IAAxM,0BAAwM;IAAxM,oBAAwM;IAAxM,gBAAwM;IAAxM,oBAAwM;IAAxM,mDAAwM;IAAxM,wJAAwM;IAAxM,wDAAwM;IAAxM;AAAwM;;AAAxM;IAAA,cAAwM;IAAxM;AAAwM;;AAAxM;;IAAA;QAAA,sBAAwM;QAAxM,aAAwM;QAAxM;IAAwM;AAAA;;AAIxM;IAAA,oBAAqC;IAArC,gBAAqC;IAArC,oBAAqC;IAArC;AAAqC;;AAIrC;IAAA,eAAgG;IAAhG,cAAgG;IAAhG,eAAgG;IAAhG,uBAAgG;IAAhG,iBAAgG;IAAhG,cAAgG;IAAhG;AAAgG;;AAAhG;;IAAA;QAAA,cAAgG;QAAhG;IAAgG;AAAA;;AAIhG;IAAA,oBAAoF;IAApF,kBAAoF;IAApF,QAAoF;IAApF,WAAoF;IAApF,uBAAoF;IAApF,aAAoF;IAApF,mBAAoF;IAApF;AAAoF;;AAApF;;IAAA;QAAA;IAAoF;AAAA;;AAIpF;IAAA,sBAAgC;IAAhC;AAAgC;;AAAhC;;IAAA;QAAA;IAAgC;AAAA;;AAIhC;IAAA,qBAAiE;IAAjE,iBAAiE;IAAjE,sBAAiE;IAAjE;AAAiE;;AAAjE;;IAAA;QAAA,sBAAiE;QAAjE;IAAiE;AAAA;;AAIjE;IAAA,mBAAgC;IAAhC,gBAAgC;IAAhC,oBAAgC;IAAhC;AAAgC;;AAIhC;IAAA,kBAAkD;IAAlD,QAAkD;IAAlD,WAAkD;IAAlD,cAAkD;IAAlD,aAAkD;IAAlD;AAAkD;;AAIlD;IAAA,cAAiP;IAAjP,WAAiP;IAAjP,uBAAiP;IAAjP,uBAAiP;IAAjP,cAAiP;IAAjP,kBAAiP;IAAjP,4DAAiP;IAAjP,eAAiP;IAAjP,4BAAiP;IAAjP,eAAiP;IAAjP,gBAAiP;IAAjP;AAAiP;;AAAjP;IAAA,oBAAiP;IAAjP;AAAiP;;AAAjP;IAAA,cAAiP;IAAjP,8BAAiP;IAAjP,mBAAiP;IAAjP;AAAiP;;AAAjP;;IAAA;QAAA,sBAAiP;QAAjP,iBAAiP;QAAjP;IAAiP;AAAA;;AAIjP;IAAA,eAA8M;IAA9M,uBAA8M;IAA9M,uBAA8M;IAA9M,cAA8M;IAA9M,kBAA8M;IAA9M,mBAA8M;IAA9M,mBAA8M;IAA9M,sBAA8M;IAA9M,eAA8M;IAA9M,gBAA8M;IAA9M,oBAA8M;IAA9M,iDAA8M;IAA9M,wJAA8M;IAA9M,wDAA8M;IAA9M;AAA8M;;AAA9M;IAAA,cAA8M;IAA9M;AAA8M;;AAA9M;;IAAA;QAAA,iBAA8M;QAA9M,qBAA8M;QAA9M,wBAA8M;QAA9M;IAA8M;AAAA;;AAGlN,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;GAEG;AACH,gDAAgD;AAE5C;IAAA,sBAAmF;IAAnF,cAAmF;IAAnF,gBAAmF;IAAnF,eAAmF;IAAnF,gBAAmF;IAAnF,oBAAmF;IAAnF;AAAmF;AAAnF;;IAAA;QAAA;IAAmF;AAAA","sourcesContent":["\n\n.input-label {\n    @apply text-defaultTextClr font-7 text-18\n}\n\n.input-field {\n    @apply  w-full mt-0.5 px-4 py-2.5 2xl:py-3 font-5 text-16 2xl:text-17 text-defaultTextClr border 2xl:border-1 border-borderClr rounded-lg 2xl:rounded-xl focus:border-primaryClr focus:outline-none transition duration-300\n}\n\n.input-field-compact {\n    @apply w-full px-3 py-2 font-5 text-16 2xl:text-17 text-defaultTextClr border border-borderClr rounded-lg focus:border-primaryClr focus:outline-none transition duration-300\n}\n\n/* date picker input */\n.input-date-field {\n    @apply mt-0.5 ps-4 py-2.5 2xl:py-3 font-5 text-16 2xl:text-17 text-defaultTextClr border 2xl:border-1 border-borderClr rounded-lg 2xl:rounded-xl focus:border-primaryClr focus:outline-none transition duration-300\n}\n\n\n.input-date-field-custom {\n    @apply   ps-4 py-3 2xl:py-3.5 font-5 text-16 2xl:text-17 text-defaultTextClr border 2xl:border-1 border-borderClr rounded-lg 2xl:rounded-xl focus:border-primaryClr focus:outline-none transition duration-300\n}\n\n.input-prefix-content {\n    @apply font-5 text-17 pr-3 border-r-2 text-darkGrayClr border-lightGrayClr\n}\n\n.input-with-prefix {\n    @apply block w-full ps-20 2xl:ps-20 p-3 2xl:p-4 font-5 text-17 text-lightGrayClr transition duration-300 border border-outlineClr rounded-lg 2xl:rounded-xl focus:ring-primaryClr focus:border-primaryClr\n}\n\n.checkbox-label {\n    @apply text-darkGrayClr font-6 text-17\n}\n\n.checkbox {\n    @apply w-5 h-5 2xl:w-6 2xl:h-6 bg-primaryClr rounded-md cursor-pointer border-2 border-outlineClr\n}\n\n.prefix-icon {\n    @apply absolute inset-y-0 start-0 flex items-center ps-5 2xl:ps-6 pointer-events-none\n}\n\n.input-error {\n    @apply border-redClr 2xl:border-2\n}\n\n.input-prefix-error {\n    @apply border-redClr border 2xl:border-2 rounded-lg 2xl:rounded-xl\n}\n\n.error-msg {\n    @apply text-redClr font-6 text-15\n}\n\n.input-suffix {\n    @apply absolute inset-y-0 right-3 flex items-center\n}\n\n.search-input {\n    @apply block ps-10 p-2 font-5 text-16 2xl:text-17 border-1 2xl:border-2 w-full border-outlineClr rounded-10 2xl:rounded-xl bg-white tracking-wide placeholder:text-disableTextClr focus:ring-primaryClr focus:outline-none focus:border-primaryClr\n}\n\n.select-field {\n    @apply px-4 py-2 2xl:py-2.5 font-5 text-16 2xl:text-17 text-darkGrayClr border-1 2xl:border-2 border-outlineClr rounded-10 focus:ring-primaryClr focus:border-primaryClr cursor-pointer transition duration-300\n}\n\n/* Styling for custom option */\n.custom-option {\n    display: flex;\n    align-items: center;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n  \n.custom-option:hover {\n    background-color: #f0f0f0;\n}\n\n.custom-option-image {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.css-hlgwow .css-19bb58m {\n    display: flex;\n    align-items: center;\n}\n\n.css-hlgwow .css-19bb58m img {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.word-breack-all {\n    word-break: break-all !important;\n}\n\n/* .css-b62m3t-container{\n    @apply w-fit\n} */\n/* Styling only the border of the select field */\n.css-b62m3t-container .css-13cymwt-control {\n    @apply p-1 font-5 text-16 2xl:text-17 text-lightGrayClr border-outlineClr rounded-xl\n}\n\n\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
